// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"345":"0b1d0c32","496":"a0c2390c","736":"144bd469"}[chunkId] + ".chunk.js";
};